
import { Grid, Users, User, FileText, Building2, Compass, Menu } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "./navigation/Logo";
import { AuthButtons } from "./navigation/AuthButtons";
import { useSession } from "@supabase/auth-helpers-react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { MobileNav } from "./navigation/MobileNav";
import { VisitorNav } from "./navigation/VisitorNav";

const MainNav = () => {
  const location = useLocation();
  const session = useSession();
  const { t } = useTranslation("nav");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const isActive = (path: string) => location.pathname === path;
  
  return (
    <header className="fixed w-full top-0 z-50 bg-white border-b shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Logo />
            {session && (
              <nav className="hidden md:flex items-center space-x-6">
                <Link to="/dashboard" className={`flex items-center space-x-2 text-sm font-medium transition-colors ${isActive("/dashboard") ? "text-primary" : "text-gray-600 hover:text-primary"}`}>
                  <Grid className="h-4 w-4" />
                  <span>{t("dashboard")}</span>
                </Link>
                
                <Link to="/profile" className={`flex items-center space-x-2 text-sm font-medium transition-colors ${isActive("/profile") ? "text-primary" : "text-gray-600 hover:text-primary"}`}>
                  <User className="h-4 w-4" />
                  <span>{t("profile")}</span>
                </Link>
                
                <Link to="/tender-management" className={`flex items-center space-x-2 text-sm font-medium transition-colors ${isActive("/tender-management") ? "text-primary" : "text-gray-600 hover:text-primary"}`}>
                  <FileText className="h-4 w-4" />
                  <span>{t("tenderManagement")}</span>
                </Link>
                
                <Link to="/company-information" className={`flex items-center space-x-2 text-sm font-medium transition-colors ${isActive("/company-information") ? "text-primary" : "text-gray-600 hover:text-primary"}`}>
                  <Building2 className="h-4 w-4" />
                  <span>{t("companyInformation")}</span>
                </Link>
                
                <Link to="/competitor-analysis" className={`flex items-center space-x-2 text-sm font-medium transition-colors ${isActive("/competitor-analysis") ? "text-primary" : "text-gray-600 hover:text-primary"}`}>
                  <Users className="h-4 w-4" />
                  <span>{t("competitors")}</span>
                </Link>
                
                <Link to="/opportunity-finder" className={`flex items-center space-x-2 text-sm font-medium transition-colors ${isActive("/opportunity-finder") ? "text-primary" : "text-gray-600 hover:text-primary"}`}>
                  <Compass className="h-4 w-4" />
                  <span>{t("opportunityFinder")}</span>
                </Link>
              </nav>
            )}
          </div>
          <div className="flex items-center">
            <AuthButtons />
            
            {/* Show menu button for visitors on all screen sizes, but only on mobile for logged-in users */}
            <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
              <SheetTrigger asChild>
                <Button 
                  variant="ghost" 
                  size="icon" 
                  className={`ml-2 ${session ? "md:hidden" : ""}`}
                >
                  <Menu className="h-5 w-5" />
                  <span className="sr-only">Toggle menu</span>
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[80vw] sm:w-[350px] pt-10">
                {session ? (
                  <MobileNav isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
                ) : (
                  <VisitorNav isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
                )}
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default MainNav;
